import React from 'react';
import Rating from '@material-ui/lab/Rating';

export const NotExistReview = () => {
  return (
    <>
      <Rating value={0} max={1} size="small" disabled readOnly />
      <span className="text-xs text-light-gray3 ml-1">まだ評価がありません</span>
    </>
  );
};
